var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1111 1H2.88889C1.84568 1 1 1.84568 1 2.88889V16.1111C1 17.1543 1.84568 18 2.88889 18H16.1111C17.1543 18 18 17.1543 18 16.1111V2.88889C18 1.84568 17.1543 1 16.1111 1Z",
    stroke: "#4800BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.4999C11.9853 15.4999 14 13.4852 14 10.9999C14 8.51466 11.9853 6.49994 9.5 6.49994C7.01472 6.49994 5 8.51466 5 10.9999C5 13.4852 7.01472 15.4999 9.5 15.4999Z",
    stroke: "#4800BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 4.77777H14.2322",
    stroke: "#4800BD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7d8d2fd63ce2eecc315dba9e41a312a1.svg";
export { ForwardRef as ReactComponent };